<div class="sys-container">
  <!-- タブナビゲーション -->
  <div class="tab-navigation">
    <div class="tabs">
      <button 
        *ngFor="let tab of tabs" 
        class="tab-button" [class.active]="activeTab === tab.id"
        (click)="switchTab(tab.id)">
        {{ tab.name }}
      </button>
    </div>
  </div>

  <!-- タブコンテンツ -->
  <div class="tab-content">
    <app-sys-batch *ngIf="visitedTabs.has('sys-batch')" [hidden]="activeTab !== 'sys-batch'"></app-sys-batch>
    <app-sys-maintenance *ngIf="visitedTabs.has('sys-maintenance')" [hidden]="activeTab !== 'sys-maintenance'"></app-sys-maintenance>
    <app-sys-privilege *ngIf="visitedTabs.has('sys-privilege')" [hidden]="activeTab !== 'sys-privilege'"></app-sys-privilege>
    <app-sys-system *ngIf="visitedTabs.has('system-settings')" [hidden]="activeTab !== 'system-settings'"></app-sys-system>
  </div>
</div>
